<template>
	<div id='ticket'>
		<mt-header :title="title" fixed>
		   <a href="javascript:void(0)" slot="left" @click="returnBack">
			    <mt-button icon="back" class="font-Yahei"></mt-button>
		   </a>
		   <a href="/" slot="right">
			    <img src='../../../static/images/home_ico_white.png' width="27"/>
		   </a>
		</mt-header>
		<main>
			<ul class='ticket-tab'>
				<li :class="{active:tab==1}" @click="changeTab(1)">
					<span>可用优惠券({{availableSize}})</span>
					<span></span>
				</li>
				<li :class="{active:tab==0}"  @click="changeTab(0)"><span>不可用优惠券({{onavailableSize}})</span><span></span></li>
			</ul>
			<div class="listwrap" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" v-show="tab==1">	
				<div class='ticket-list' :class="{activemain:tab==1}">
					<!--<span><input type="radio" style="width: 18px; height: 18px; position: absolute;right: 0;top: 0;" /></span>-->
					<section class="valueticket unused" v-for="(item,$index) in available" @click="selectticket(item,$index)">
						<div class="ticketwarp-buttom">
							<div v-show="indexflag==$index" class="ticket-select-right"><div class="iconswrap"><span class="iconfont icon-gouxuan"></span></div></div>
							<div class="ticketwarp">
								<span class='ticket-money'>
									<span>￥</span>
									<span class='ticket-num'>{{item.yamount}}</span></br><span v-show="item.fullamount!='-1'">满{{item.fullamount}}元可用</span></span>
									<span class='ticket-range' :class="item.fullamount!=-1?'pmt15':'pmt35'">{{item.yname}}</span>
							</div>
							
						</div>
						<div class='ticket-timelimit'>
							<div>有效期：{{formatDate(item.startDate)}}-{{formatDate(item.endDate)}}</div>
							<div class="qqdot dotleft"></div>
							<div class="qqdot dotright"></div>
						</div>
					</section>
					<!--<section :style="{height:sectionHeight}" class='used'>
						<div><span class='ticket-money'><span>￥</span><span class='ticket-num'>15</span></br>满16元可用</span><span class='ticket-range'>全场通用</span></div>
						<div class='ticket-timelimit'>有效期：2018.04.25-2018.05.02</div>
					</section>
					<section :style="{height:sectionHeight}" class='select'>
						<div><span class='ticket-money'><span>￥</span><span class='ticket-num'>15</span></br>满16元可用</span><span class='ticket-range'>全场通用</span></div>
						<div class='ticket-timelimit'>有效期：2018.04.25-2018.05.02</div>
					</section>-->
					<div class='ticket-nomore'>
						<img src="../../../static/images/nomore.png"/>
					</div>
				</div>
				<div class="loading-text" v-show="loadingTextBtn==true">
		 		 	<span class="text-center inline-block mt5">
		 		 		<label v-text="loadingText" class="float-left font-size7"></label>
		 		 		<mt-spinner class="float-left ml5" v-show="loadingComplete==false" type="snake" :size="10"></mt-spinner>
		 		 	</span>
		 		 </div>
			</div>			
			<div class="listwrap1" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" v-show="tab==0">	
				<div class='ticket-list' :class="{activemain:tab==0}">
						<section class='used' v-for="item in available">
							<div class="ticketwarp ticketwarp-buttom"><span class='ticket-money'><span>￥</span><span class='ticket-num'>{{item.yamount}}</span></br><span v-show="item.fullamount!='-1'">满{{item.fullamount}}元可用</span></span><span class='ticket-range'>{{item.yname}}</span></div>
							<div class='ticket-timelimit'>
								<div>有效期：{{formatDate(item.startDate)}}-{{formatDate(item.endDate)}}</div>
								<div class="qqdot dotleft"></div>
							    <div class="qqdot dotright"></div>
							</div>
						</section>
						<div class='ticket-nomore'>
							<img src="../../../static/images/nomore.png"/>
						</div>
				</div>
			</div>
			<p class="p-input" v-show="tab==1"><input type="button" value="确认" class="btnLogin" @click="confirmTicket"/></p>
		</main>
		
	</div>
</template>

<script>
	import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
				ticketorderId: this.$route.query.ticketorderId,//订单默认ID
				indexflag:0,
				pid:localStorage.getItem("pid"),//商品ID号
				num:localStorage.getItem("num"),//数量
				username:localStorage.getItem("username"),//用户名
				backgroundflag:true,
				tab:1,
				title:'使用优惠券',
				available:[],
				//noavailable: [],
				loadingText:"加载中",
                loading:false,
                loadingTextBtn:"",
                page:1,
                pageN:1,
                loadingComplete:false,
                totalPages:"",
                md5sign:this.Act_md5sign,
                signMd:"",   
                availableSize:"",
                onavailableSize:"",
                mtTop:"",
			}
		},
		created:function(){
			if(this.num==""){
		       this.num=1;
		    };
			this.ticketAvailable();
	    },
	    methods: {
			returnBack(){
	       	 	this.$router.go(-1);
	     	},
			changeTab(item){
				this.tab = item;
				this.page=1;
				this.ticketAvailable();
			},
			formatDate(date){
				return date.substr(0,10).replace(/[-]/g,".");
			},
			selectticket(item,index){
				if(this.indexflag == index){
					this.indexflag = -1;
				}else{
					this.indexflag = index;
				}
			},
			ticketAvailable(){
				Indicator.open();
				this.signMd=md5('pid='+this.pid+'&num='+this.num+'&uid='+this.username+'&isuse='+this.tab+'&'+this.md5sign);
				this.$http.post(this.URL_PREFIX+"/activity/findAvailableCoupon",{pid:this.pid, num:this.num, uid:this.username,isuse:this.tab,sign:this.signMd,page:this.page,rows:15})
		  	  .then((res) =>{	
		  	  	Indicator.close();
			  	this.availableSize=res.data.obj.availableSize;
			  	this.onavailableSize=res.data.obj.onavailableSize;
			  	this.totalPages=res.data.pageSize;
		  	  	 var avalength = res.data.obj.available;
		  	  	 this.available = res.data.obj.available;
		  	  	if(this.ticketorderId!=undefined&&res.data.obj.available.length!=0){
		  	  		for(var i=0; i<avalength.length; i++){
		  	  			if(avalength[i].orderId==this.ticketorderId){
		  	  				this.indexflag = i;
		  	  			} 
		  	  		}
		  	  	}
		  	  	
		  	  });
			},
			confirmTicket(){
				if(this.indexflag==-1){
					this.$router.push({path: "/Order/index",query: {indexflag:this.indexflag}});
				}else{
					var yamountback = this.available[this.indexflag].yamount;
				    var orderIdback = this.available[this.indexflag].orderId;
					this.$router.push({path: "/Order/index",query: {yamountback:yamountback,orderIdback:orderIdback,indexflag:this.indexflag}});					
				}
//				if(this.indexflag==-1){
//					localStorage.setItem('defaultval1','0');//没选中
//				}else{
//					localStorage.setItem('defaultval1',val);//选中selectTicketIndex
//					localStorage.setItem('ticketId',ticketId);//保存选中的ID
//				}
			},
			 //加载更多
		    loadMore(){
		      this.loading = true;
		      setTimeout(() => {
		      this.loadingTextBtn=true;
	          this.page++;
	          if(this.page<=this.totalPages){
	            this.$http.post(this.URL_PREFIX+"/activity/findAvailableCoupon",{pid:this.pid, num:this.num, uid:this.username,isuse:this.tab,sign:this.signMd,page:this.page,rows:15})
		  	    .then((res) =>{
		  	  	     this.available=this.available.concat(res.data.obj.available);
		  	    });
	          }else{
	            this.loadingText="";
	            this.loadingComplete=true;
	            this.loadingTextBtn=false;
	          }
	            this.loading = false;
	            
	        }, 2500);
		    },
	    }
	  }
</script>

<style scoped="scoped">
/*@import "../../../static/css/iconfont.css";*/
    /*.icon {
	   width: 1em; height: 1em;
	   vertical-align: -0.15em;
	   fill: currentColor;
	   overflow: hidden;
	}*/
	#ticket{
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	main {
		width: 100%;
		height: auto;
		margin-top: 40px;
	}
	.ticket-tab {
		display: flex;
		top: 0px;
		left: 0px;
	}
	.ticket-tab > li {
		flex: 1;
		text-align: center;
	}
	.ticket-tab > li > span:first-of-type {
		display: block;
		color: #666;
		font-size: 16px;
		line-height: 40px;
	}
	.ticket-tab > li.active > span{
		color: #FF892A;
		border-collapse: 50%;
	}
	.ticket-tab > li.active > span:last-of-type {
		width: 40%;
		display: block;
		margin: 0 auto;
		height: 2px;
		background: #FF892A;
	}
	div.ticket-list {
		width: 100%;
		display: none;
		background: #eee;
		height: 100%;
		padding-top: 10px;
	}
	.activemain{
		display: block!important;
	}
	#ticket section {
		margin: 5px 4%;
		color: #fff;
		font-size: 1.3em;
		position: relative;
		/*overflow: hidden;*/
	}
	/*不带勾*/
	section.unused {
		/*background: url(../../../static/images/sale.png) no-repeat;
		background-size: 100% auto;*/
		background: -webkit-linear-gradient(left, #ff6067 , #fea370); /* Safari 5.1 - 6.0 */
	    background: -o-linear-gradient(right, #ff6067, #fea370); /* Opera 11.1 - 12.0 */
	    background: -moz-linear-gradient(right, #ff6067, #fea370); /* Firefox 3.6 - 15 */
	    background: linear-gradient(to right, #ff6067 , #fea370); /* 标准的语法 */
	    border-radius:5px ;
	}
	/*选中*/
	/*section.select {*/
		/*background: url(../../../static/images/sale_choose.png) no-repeat;
		background-size: 100% auto;*/
		/*background-color: red;*/
	/*}*/
	/*灰色*/
	section.used {
		/*background: url(../../../static/images/unsale.png) no-repeat;
		background-size: 100% auto;*/
		background: -webkit-linear-gradient(left, #ccc , #ccc); /* Safari 5.1 - 6.0 */
	    background: -o-linear-gradient(right, #ccc, #ccc); /* Opera 11.1 - 12.0 */
	    background: -moz-linear-gradient(right, #ccc, #ccc); /* Firefox 3.6 - 15 */
	    background: linear-gradient(to right, #ccc , #ccc); /* 标准的语法 */
	    border-radius:5px ;
	}
	/*section > div:last-of-type {
		padding:3% 0 1% 6%;
	}*/
	.ticketwarp-buttom{
		border-bottom: 1px dashed #E5E5E5;
		overflow: hidden;
		position: relative;
	}
	.ticket-select-right{
		position: absolute;
		transform: rotate(48deg);
		top: -27px;
		right: -35px;
		width: 70px;
		height: 60px;
		background: #ff2a00;
	}
	.qqdot{
		position: absolute;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background: #eee;
	}
	.iconswrap{
		position: absolute;
		left: 17px;
		top: 40px;
		transform: rotate(-41deg);
	}
	.dotleft{
		top: -7px;
		left: -7px;
	}
	.dotright{
		right: -7px;
		top: -7px;
	}
	.ticketwarp{
	}
	section .ticket-money {
		overflow: hidden;
	    padding: 5% 4% 5% 4%;
	    float: left;
	}
	section .ticket-money > span:first-of-type {
		font-size: 1.3em;
	}
	section .ticket-num {
		font-size: 30px;
	}
	section .ticket-range {
		font-size: 14px;
		position: relative;
		float: left;
		margin: 8% 0% 5% 0%;
		width: 50%;
	}
	.ticket-nomore{width: 100%; text-align: center;}
	.ticket-nomore img{width:50%;}
	.ticket-timelimit {
		position: relative;
		line-height: 28px;
		padding-left: 6%;
	}
	.p-input{width: 100%;position: absolute;bottom: 0; left: 0; background-color: #eee;}
	#ticket .btnLogin{width: 94%;height: 40px;background: #ff8920;color: #fff;font-size: 1.0rem;border-radius: 5px;-webkit-border-radius: 5px;margin: 10px 10px 10px 10px; border: none;line-height: 40px;box-sizing: content-box;}
	
	.listwrap{position: absolute;left: 0; top: 85px; bottom: 60px; overflow: hidden;overflow-y: auto; background: #eee;width: 100%;}
	.listwrap1{position: absolute;left: 0; top: 85px; bottom: 0px; overflow: hidden;overflow-y: auto; background: #eee;width: 100%;}
	.loading-text{text-align: center;}
	
	/*.valueticket{height: 101px;}*/
	/*.radioinput{width: 38px; height: 38px; position: absolute;right: 0;top: 0; border: none;-webkit-appearance: none; background: url(../../../static/images/sale_02.png) no-repeat;}
	.radioinput:checked{width: 38px; height: 38px; position: absolute;right: 0;top: 0; border: none;-webkit-appearance: none; background: url(../../../static/images/sale_choose_02.png) no-repeat;}*/
</style>


// WEBPACK FOOTER //
// src/views/Ticket/useTicket.vue